import CatalogIconImageDark from "./../../icons/default/catalogDark.png";

import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const CatalogDarkIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return <img style={style} className={className} src={CatalogIconImageDark} />;
};
